import React, {Component} from 'react'
import {withRouter} from 'react-router-dom'

import Header from './Header'
import Footer from './Footer'
import About from './About'
import Routes from './Routes'

import './style.css'

@withRouter
class Landing extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const {pathname} = this.props.location
    const about = pathname !== '/login' && pathname.indexOf('/password-recovery') === -1
    return(
      <div className='landing-wrapper'>
        <Header about={about}/>
        <Routes/>
        {about && <About/>}
        <Footer/>
      </div>
    )
  }
}

export default Landing
